import homeNewCSS from 'bundle-text:../css/home_new.css';
import styleCSS from 'bundle-text:../css/style.css';

const style = document.createElement('style');
style.id = 'injected-css';
style.textContent = homeNewCSS + styleCSS 
document.head.insertBefore(style, document.head.firstChild);

// show body after css inject
document.body.style.visibility = 'visible';